/**
 * Test environment configuration
 */
export const environment = {
  production: false,
  //apiBaseUrl: 'https://wa-euwe-puroappapi-test-01.azurewebsites.net',
  apiBaseUrl: 'https://api-managment-digitalizcija.azure-api.net/puro-checkin-api-test',
  //hostURL: 'https://brave-river-01e7e4203.7.azurestaticapps.net',
  hostURL:'https://purocheckin.test.valamar.hr',
  azureAd: {
    tenantId: 'c7223f2c-1ba2-43c8-be7f-57e6e1465036',
    clientId: '6cd20780-b7db-4332-851e-249e1174e4fa',
    redirectUri: window.location.origin,
    authority: 'https://login.microsoftonline.com/c7223f2c-1ba2-43c8-be7f-57e6e1465036',
    apiScope: 'api://a32c62ef-0709-4f6e-8a6d-b943ae948f52/All',
    baseURL: window.location.origin
  },
  title: 'Puro Beach CheckIn (Test)'
};
